<div class="faq">
  <app-page-header
    (searchEvent)="handleSearch($event)"
    [pageTitle]="'FAQ'"
    [numberOfItem]="faqCount"
    [loading]="faqLoading"
  >
    <button class="button" (click)="toggleTopicModal(true)" addButton>
      <img src="assets/images/add.svg" alt="+" />
      Add <span>Topic</span>
    </button>
  </app-page-header>

  <div *ngIf="faqLoading">
    <div class="faq__list faq__list--loader">
      <ngx-slick-carousel class="carousel" [config]="slideConfig">
        <div class="faq__item" ngxSlickItem *ngFor="let i of [].constructor(5)">
          <app-skeleton width="100%" height="150px"></app-skeleton>
        </div>
      </ngx-slick-carousel>
    </div>

    <div class="faq__content">
      <div class="faq__add flex justify-end">
        <app-skeleton width="162px" height="50px"></app-skeleton>
      </div>

      <app-skeleton
        *ngFor="let i of [].constructor(6)"
        width="100%"
        height="50px"
        margin="0 0 10px"
      ></app-skeleton>
    </div>
  </div>
  <ng-container *ngIf="!faqLoading">
    <div class="faq__list" *ngIf="faqList.length > 0; else noDataFound">
      <app-topic-carousel
        [faqList]="faqList"
        (onEditTopic)="onEditTopic($event)"
        (onFaqUpdate)="onFaqUpdate()"
        (onFaqClick)="onFaqClick($event)"
        [selectedTopic]="selectedTopic"
      ></app-topic-carousel>
    </div>

    <div class="faq__content">
      <div class="faq__add flex justify-end">
        <ng-container *ngIf="faqList.length > 0">
          <button class="button" (click)="toggleQuestionModal(true)">
            <img src="assets/images/add.svg" alt="+" />
            Add FAQ
          </button>
        </ng-container>
      </div>
      <ng-container
        *ngIf="selectedTopic && selectedTopic.faqs.length > 0; else noDataFound"
      >
        <app-topic-question
          (onEdit)="onEditQuestion($event)"
          (onDelete)="deleteQuestion($event)"
          [questions]="selectedTopic.faqs"
          [search]="search.trim() || ''"
          [deleteLoading]="deleteLoading"
        ></app-topic-question>
      </ng-container>
    </div>
  </ng-container>
</div>

<app-modal
  *ngIf="showTopicModal"
  (closeModal)="toggleTopicModal(false)"
  [modalTitle]="editTopic ? 'Edit Topic' : 'Add Topic'"
>
  <app-add-edit-topic
    (onClose)="toggleTopicModal(false)"
    [topic]="editTopic"
    (onComplete)="onFaqUpdate()"
  ></app-add-edit-topic>
</app-modal>

<app-modal
  *ngIf="showQuestionModal"
  [modalTitle]="editQuestion ? 'Edit Question' : 'Add Question'"
  (closeModal)="toggleQuestionModal(false)"
>
  <app-add-edit-question
    (onClose)="toggleQuestionModal(false)"
    (onSubmit)="onSubmit($event)"
    [editQuestion]="editQuestion"
    [loading]="questionLoading"
  ></app-add-edit-question>
</app-modal>

<ng-template #noDataFound>
  <div class="faq__nodata">No Data Found</div>
</ng-template>
